import type { ReactNode } from "react";

import EmployeeSignIn from "~/components/employee/employee-sign-in";
import NoPermissionAlert from "~/components/employee/no-permission-alert";
import { PermissionContext } from "~/hooks/use-permission";

interface PermissionProviderProps {
  children: ReactNode;
}

export function PermissionProvider({ children }: PermissionProviderProps) {
  const context = {};

  return (
    <PermissionContext.Provider value={context}>
      {children}
      <EmployeeSignIn />
      <NoPermissionAlert />
    </PermissionContext.Provider>
  );
}
